/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";

type Props = {
	v?: number
}

export class VGap
	extends React.Component<Props> {

	render() {
		const v = this.props.v;
		return <div style={{height: v ? v : 9, pointerEvents: 'none'}}/>;
	}

}
